import { KeyRecoilProps } from '@/shared/model';
import useTabBeatUIEffect from './useTabBeatUIEffect';

/**
 * Runs the beat tab's modal and date-picking side effects without rendering anything.
 *
 * @param keyRecoil - The tab key selecting which report tab's state these effects drive.
 * @returns Null, since this component renders no markup.
 */
export const TabBeatUIEffect = ({ keyRecoil }: KeyRecoilProps): null => {
  useTabBeatUIEffect({ keyRecoil });
  return null;
};
